const descriptorsList = {
  bindings: {
    module: '<',
    onDelete: '&',
    onUpdate: '&',
    sanctionedExists: '<',
    validExists: '<',
    engineeringExists: '<'
  },
  templateUrl: '/modules/packageManagement/descriptor-management/descriptors-list/descriptors-list.html',
  controller: 'descriptorsListController',
};

angular
  .module('configuration-management.module')
  .component('descriptorsList', descriptorsList);